import { api, handleApiResponse, handleApiError } from '@/lib/api';

export interface TransferTituloRequest {
  tituloId: string;
  fromKanbanId: string;
  toKanbanId: string;
  toEtapaId?: string; // Opcional: etapa específica no kanban destino
  motivo?: string; // Motivo da transferência
}

export interface TransferTituloResponse {
  success: boolean;
  message: string;
  data?: {
    tituloId: string;
    fromKanban: {
      id: string;
      nome: string;
    };
    toKanban: {
      id: string;
      nome: string;
    };
    toEtapa?: {
      id: string;
      nome: string;
    };
  };
}

export const tituloTransferService = {
  async transferTitulo(data: TransferTituloRequest): Promise<TransferTituloResponse> {
    try {
      const response = await api.post('/titulos/transfer', data);
      return handleApiResponse(response);
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  },

  async getTransferHistory(tituloId: string): Promise<any[]> {
    try {
      const response = await api.get(`/titulos/${tituloId}/transfer-history`);
      return handleApiResponse(response);
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  },

  async getAvailableKanbansForTransfer(tituloId: string): Promise<any[]> {
    try {
      const response = await api.get(`/titulos/${tituloId}/available-kanbans`);
      return handleApiResponse(response);
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
};
